import Component from '@glimmer/component';
import { action } from '@ember/object';
import { sortBy } from 'lodash';
import { tracked } from '@glimmer/tracking';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwGroupSearch extends Component {
  @tracked searchDropdownOpened;
  @tracked searchPhrase = '';
  @tracked itemsSearched;

  constructor() {
    super(...arguments);
    installDropdown(this, 'searchDropdownOpened');
  }

  willDestroyElement() {
    this.unbindPubSub();
  }

  @action
  updateSearch() {
    const hasSearchPhrase = !!this.searchPhrase?.length;

    this.setDropdownRef?.(hasSearchPhrase);

    if (hasSearchPhrase) {
      this.doSearch();
    }
  }

  doSearch() {
    const all = this.args.itemsToSearch || [];
    const lowerPhrase = this.searchPhrase ? this.searchPhrase.toLowerCase() : '';
    const searched = all.filter((g) => {
      return g.name.toLowerCase().indexOf(lowerPhrase) > -1;
    });

    this.itemsSearched = sortBy(searched, (g) => {
      return g.name.toLowerCase();
    });
  }

  @action
  click() {
    return false;
  }

  @action
  clearSearch() {
    this.searchPhrase = '';
    this.setDropdownRef?.(false);
  }
}